export var AxisDirection;
(function (AxisDirection) {
    AxisDirection[AxisDirection["Y_NEGATIVE"] = 0] = "Y_NEGATIVE";
    AxisDirection[AxisDirection["X_POSITIVE"] = 1] = "X_POSITIVE";
    AxisDirection[AxisDirection["Y_POSITIVE"] = 2] = "Y_POSITIVE";
    AxisDirection[AxisDirection["X_NEGATIVE"] = 3] = "X_NEGATIVE";
})(AxisDirection || (AxisDirection = {}));
export function isHorizontal(direction) {
    switch (direction) {
        case AxisDirection.Y_POSITIVE:
        case AxisDirection.Y_NEGATIVE:
            return false;
        case AxisDirection.X_NEGATIVE:
        case AxisDirection.X_POSITIVE:
            return true;
    }
}
export function isVertical(direction) {
    return !isHorizontal(direction);
}
